import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { connectProps } from 'store';
import { langProp } from 'model/component-props';
import Modal from 'react-responsive-modal';


import content from './content';
import './itemCard.css';


class ItemCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }

    onOpenModal = () => {
        this.setState({ open: true });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    addDefaultSrc(ev){
        ev.target.src = `${process.env.REACT_APP_NODE_SERVER}/notfound.png`;
        ev.target.onerror = null;
    }

    render(){
        const { onClick, url, id, description, sampledescription, inventory, weight, composition, width, langProp } = this.props;
        const { open } = this.state;
        return (
            <div>
                <Card
                    onClick={onClick}
                    //onClick={this.onOpenModal}
                    className='itemCard'>
                    <CardContent>
                        <div style={{height: '106px'}}>
                            <img className="item-photo" 
                              onError={this.addDefaultSrc} 
                              src={url} alt="">
                            </img>
                        </div>
                        <table className="container-text">
                            <tbody>
                                <tr>
                                    <td className="id">{id}</td>
                                </tr>
                                <tr>
                                    <td className="description">{description}</td>
                                    <td className="inventory">{parseFloat(inventory).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ΜΕΤ</td>
                                </tr>
                                { /*<tr>
                                    <td className="unitprice">{parseFloat(unitprice).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                </tr> */}
                            </tbody>
                        </table>
                    </CardContent>
                </Card>
           <div>
                <Modal
                    open={open}
                    onClose={this.onCloseModal}
                    closeOnEsc={true}
                    closeOnOverlayClick={true}
                    closeIconSize={30}
                    showCloseIcon={true}
                    center>
                    <CardContent className="sample-description text">
                        <div>
                            {content[langProp].SampleDescription}
                            <span className="item-text">{sampledescription}</span>
                        </div>
                    </CardContent>
                    <CardContent className="special-weight text">
                        <div>
                            {content[langProp].SpecialWeight}
                            <span className="item-text">{weight}</span>
                        </div>
                    </CardContent>
                    <CardContent className="composition text">
                        <div>
                            {content[langProp].Composition}
                            <span className="item-text">{composition}</span>
                        </div>
                    </CardContent>
                    <CardContent className="width text">
                        <div>
                            {content[langProp].Width}
                            <span className="item-text">{width}</span>
                        </div>
                    </CardContent>
                </Modal>
            </div>
            </div>
        );
    }
}


export default connectProps(langProp)(ItemCard);



// WEBPACK FOOTER //
// ./src/components/itemcard/ItemCard.js